import { clamp } from '@blocksuite/global/gfx';

import { createPropertyConvert } from '../core/index.js';
import {
  normalizeDate,
  normalizeDateRange,
} from '../core/logical/date-value.js';
import { datePropertyModelConfig } from './date/define.js';
import { dateRangePropertyModelConfig } from './date-range/define.js';
import { multiSelectPropertyModelConfig } from './multi-select/define.js';
import { numberPropertyModelConfig } from './number/define.js';
import { progressPropertyModelConfig } from './progress/define.js';
import { selectPropertyModelConfig } from './select/define.js';

export const presetPropertyConverts = [
  // date <-> date-range is lossless in both directions: the `date` type has
  // always accepted the same `{ start, end?, hasTime? }` shape
  createPropertyConvert(
    datePropertyModelConfig,
    dateRangePropertyModelConfig,
    (property, cells) => ({
      property,
      cells: cells.map(v => normalizeDateRange(v) ?? undefined),
    })
  ),
  createPropertyConvert(
    dateRangePropertyModelConfig,
    datePropertyModelConfig,
    (property, cells) => ({
      property,
      cells: cells.map(v => normalizeDate(v) ?? undefined),
    })
  ),
  createPropertyConvert(
    multiSelectPropertyModelConfig,
    selectPropertyModelConfig,
    (property, cells) => ({
      property,
      cells: cells.map(v => v?.[0]),
    })
  ),
  createPropertyConvert(
    numberPropertyModelConfig,
    progressPropertyModelConfig,
    (_property, cells) => ({
      property: {},
      cells: cells.map(v => clamp(v ?? 0, 0, 100)),
    })
  ),
  createPropertyConvert(
    progressPropertyModelConfig,
    numberPropertyModelConfig,
    (_property, cells) => ({
      property: {
        decimal: 0,
        format: 'number' as const,
      },
      cells: cells.map(v => v),
    })
  ),
  createPropertyConvert(
    selectPropertyModelConfig,
    multiSelectPropertyModelConfig,
    (property, cells) => ({
      property,
      cells: cells.map(v => (v ? [v] : undefined)),
    })
  ),
];
